// import React from "react";
// import { FieldError, UseFormRegister } from "react-hook-form";

// type CheckboxValue = {
//   value: string | undefined;
//   text: string | false | undefined;
//   id?: number | string | undefined;
// };

// type Props = {
//   name: string;
//   label: string;
//   valuesArr?: CheckboxValue[];
//   register: UseFormRegister<any>;
//   validation?: Record<string, any>;
//   error?: FieldError;
//   disabled?: boolean;
//   className?: string;
//   otherName?: string;
// };

// export default function Checkbox({
//   name,
//   label,
//   className,
//   valuesArr,
//   otherName,
//   register,
//   validation,
//   error,
//   disabled = false,
// }: Props) {
//   return (
//     <div className={`text-[#1E293B] space-y-1 ${className}`}>
//       {label && <label className="block text-sm w-full">{label}</label>}
//       <div className={`flex-wrap gap-x-6 gap-y-3 py-3 ${otherName}`}>
//         {valuesArr?.map((v, i) => {
//           const id = `checkbox-${name}-${v.value}-${i}`;
//           return (
//             <div
//               className={`flex items-center ${
//                 disabled ? "opacity-60" : "cursor-pointer"
//               }`}
//               key={id}
//             >
//               <label className="relative flex items-center cursor-pointer">
//                 <input
//                   type="checkbox"
//                   id={id}
//                   value={v.value}
//                   disabled={disabled}
//                   {...register(name, validation)}
//                   className="peer h-5 w-5 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037] transition-all
//                              bg-white checked:bg-[#FBD037] checked:text-white"
//                 />
//                 {/* Checkmark shown on peer-checked */}
//                 <span className="absolute text-[10px] font-bold text-white peer-checked:opacity-100 opacity-0 transition-opacity duration-200 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
//                   ✓
//                 </span>
//               </label>
//               <label
//                 htmlFor={id}
//                 className="ml-2 text-black cursor-pointer text-sm font-medium"
//               >
//                 {v.text}
//               </label>
//             </div>
//           );
//         })}
//       </div>
//       {error && (
//         <span className="text-red-500 text-sm min-h-[0.5rem] block pl-3">
//           {error?.message || ""}
//         </span>
//       )}
//     </div>
//   );
// }

import React from "react";
import {
  FieldError,
  FieldErrors,
  UseFormRegister,
  RegisterOptions,
} from "react-hook-form";
import { useLanguage } from "../../context/LanguageContext";

type CheckboxValue = {
  value: string | undefined;
  text: string | false | undefined;
  id?: number | string | undefined;
};

type Props = {
  name: string;
  label: string;
  valuesArr?: CheckboxValue[];
  register: UseFormRegister<any>;
  validation?: RegisterOptions;
  error?: FieldError | FieldErrors | any; // allow nested error
  disabled?: boolean;
  className?: string;
  otherName?: string;
};

export default function Checkbox({
  name,
  label,
  className,
  valuesArr,
  otherName,
  register,
  validation,
  error,
  disabled = false,
}: Props) {
  const { t } = useLanguage();
  return (
    <div className={`text-[#1E293B] space-y-1 ${className}`}>
      {label && <label className="block text-sm w-full">{t(label)}</label>}
      <div className={`flex flex-wrap gap-x-6 gap-y-3 py-3 ${otherName}`}>
        {valuesArr?.map((v, i) => {
          const id = `checkbox-${name}-${v.value}-${i}`;
          return (
            <div
              className={`flex items-center ${
                disabled ? "opacity-60" : "cursor-pointer"
              }`}
              key={id}
            >
              <label className="relative flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  id={id}
                  value={v.value}
                  disabled={disabled}
                  {...register(
                    name.endsWith("[]") ? name : `${name}[]`,
                    validation
                  )}
                  className="peer h-5 w-5 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037] transition-all 
                             bg-white checked:bg-[#FBD037] checked:text-white"
                />
                {/* White checkmark on selected */}
                <span className="absolute text-xs font-bold text-white peer-checked:opacity-100 opacity-0 transition-opacity duration-200 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
                  ✓
                </span>
              </label>
              <label
                htmlFor={id}
                className="ml-2 text-black cursor-pointer text-sm font-medium cursor-pointer"
              >
                {t(v.text || "")}
              </label>
            </div>
          );
        })}
      </div>
      {error && (
        <span className="text-red-500 text-sm min-h-[0.5rem] block pl-3">
          {error?.message ? t(error.message) : ""}
        </span>
      )}
    </div>
  );
}
